import React from 'react';
import { useTranslation } from '../../../plugins/i18next/ea-react-i18next';
import easyRegister from '../../../assets/images/products/tipster/easy_register.svg'
import totallyFree from '../../../assets/images/products/tipster/free.svg'
import privacySecured from '../../../assets/images/products/tipster/privacy_secured.svg'
import funGuaranteed from '../../../assets/images/products/tipster/fun_guaranteed.svg'

const DetailsList: { item: string; detailImg: string }[] = [
    { item: "easyRegister", detailImg: easyRegister },
    { item: "totallyFree", detailImg: totallyFree },
    { item: "privacySecured", detailImg: privacySecured },
    { item: "funGuaranteed", detailImg: funGuaranteed }
];

const DetailsIcons: Record<string, string> = {
    "easyRegister": easyRegister,
    "totallyFree": totallyFree,
    "privacySecured": privacySecured,
    "funGuaranteed": funGuaranteed,
};


const CompanyCulture = () => {
    const { t } = useTranslation("components", { keyPrefix: 'products.tipster.tipsterDetails' });

    return (
        <div className="tipster-details ptb-70">
            <div className="features cardgap">
                {DetailsList.map((data, index) => (
                    <div className={`carddisplay`} key={index}>
                        <div className={`tipster-details-container`}>
                            <div className="icon">
                                <img src={DetailsIcons[data.item]} alt={`${t(`${data.item}.title`)} icon`} />
                            </div>
                            <h3>{t(`${data.item}.title`)}</h3>
                            <p>{t(`${data.item}.details`)}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default CompanyCulture;
